import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  VertContainer, Row, Col, VertImage, VertSkeleton, VertCarousel,
} from '@vertem-core/vertice-ds';
import { useSelector } from 'react-redux';
import PipeProvider from 'Services/Providers/PipeProvider';
import { filterTradeMenuByType } from 'Utils/filterTradeMenuByType';
import isExternalLink from 'Utils/isExternalLink';
import { Link } from 'react-router-dom';
import { combineArrayOfObjects, keyChanges, parseQueryString } from 'Utils/parseQueryStringToArray';
import CreateSearchHash from 'Utils/createSearchHash';
import { useMediaQuery } from 'react-responsive';

const getSrcByQtyServices = (ShowcaseItemsQty) => {
  if (ShowcaseItemsQty > 2) {
    return '-peq';
  } else if (ShowcaseItemsQty === 2) {
    return '-med';
  } else if (ShowcaseItemsQty === 1) {
    return '-gde';
  }
  return '-gde';
}
const getUrlPath = (path) => {
  const splitParams = parseQueryString(path, ['category', 'vendor', 'search' ]);

  let newPath = path;
  if (splitParams.length > 0) {
    const keyMapping = {
      "vendors": "vendor",
    };
    const newArray = splitParams.map(obj => keyChanges(obj, keyMapping));
    const newPathObject = combineArrayOfObjects(newArray)
    newPath = `/search/1/filter/${CreateSearchHash({}, newPathObject)}`;
  }
  return newPath
}
export const getFilteredTradeMenu = (CmsStatic, type) => {
  const { cms: { tradeMenu } } = CmsStatic;
  const targetType = type;
  const filteredItem = filterTradeMenuByType(tradeMenu, targetType);
  return filteredItem;
}

const ShowcaseImagesWrapper = ({ children }) => {
  const isLargeScreen = useMediaQuery({ minWidth: 1200 });

  const settings = {
    slidesToShow: 4,
    infinite: false,
    slidesToScroll: 2,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          infinite: false,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };
    return (
      <VertContainer data-testid="vert-box-showcase" className="vert-box-showcase vert-box-showcase-images  margin-bottom-big" spacingX='regular'>
        <Row className="vert-showcase-wrapper" gutter={16} spacing={'small'}>
              {
              isLargeScreen ? (
                  <>
                   {children}
                  </>
              ) : (
                <div  className='w-100'>
                  <VertCarousel { ...settings }>
                    {children}
                  </VertCarousel>
                </div>
              )
            }
        </Row>
      </VertContainer>
    );
  };
ShowcaseImagesWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  slidesToShow: PropTypes.number
};


const CreateLink = ({ children, url, target="_self" }) => {
  if (isExternalLink(url)) {
    return <a href={url} target={target}>
      { children }
    </a>
  } else {
    const newPath = getUrlPath(url);
    return <Link to={newPath || '#'} target={target}>
      { children }
    </Link>
  }
}

const ShowcaseImages = ({ type }) => {

  const CmsStatic = useSelector(({ CmsStatic: data }) => data);
  const [servicesItem, setServicesItem] = useState([]);
  const [isVisible, setIsVisible] = useState(false);

  const [segmentId, setSegmentId] = useState(process.env.REACT_APP_TENANT_ID);
  const userProfile = useSelector((state) => state.oidc.user?.profile);

  useEffect(() => {
    if (CmsStatic?.requestMake && !CmsStatic?.isLoading) {
      const filteredShowcaseItems = getFilteredTradeMenu(CmsStatic, type);
      setServicesItem(filteredShowcaseItems);
    }
  }, [CmsStatic?.requestMake]);

  useEffect(() => {
    if (userProfile && userProfile['custom:catalog_id']) {
      const catalogId = userProfile['custom:catalog_id'];
      const segments = process.env.REACT_APP_MENU_SEGMENTS || `1`;
      let segmentsArray = segments.split(',');

      if (segmentsArray.includes(catalogId)) {
        setSegmentId(catalogId);
      } else if (segmentsArray.length === 1) {
        setSegmentId(segmentsArray[0]);
      }

    }
  }, [userProfile]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(true);
    }, 1000);
    return () => clearTimeout(timeout);
  }, []);


  const sizeImage = getSrcByQtyServices(servicesItem.length);
  const items = servicesItem.map((item, index) => {
    const { icon, label, path } = item;
    let imageSrc = icon;
    if (type === 'services') {
      imageSrc = icon + sizeImage + '.png';
    }

    return (
      <Col xs={24} sm={24} md={24} lg={24} xl={3} key={`showcase-col-index-${index}`} className="card-service padding-y-extra-small" style={!isVisible && { visibility: `hidden` }}>
        <CreateLink key={`showcase-link-index-${index}`} url={path}>
          <VertImage
              alt={label}
              key={`showcase-image-index-${index}`}
              src={imageSrc}
              className='w-100'
              placeholder="https://vertice-ds.s3.amazonaws.com/Assets/Images/fallbacks/fallback-img-store.png"
              fallback="https://vertice-ds.s3.amazonaws.com/Assets/Images/fallbacks/fallback-img-store.png"
            />
        </CreateLink>
      </Col>
    );
  });

  return (
    <PipeProvider
        apiSymbols={[{ symbol: 'FETCH_CMS_STATIC', alias: 'cmsMenu', payload: {
          segment: segmentId
          } }]}
        loadingComponent={
            <VertSkeleton paragraph={{ rows: 1 }} active title={false} />
        }
    >
        <ShowcaseImagesWrapper QtyServices={servicesItem.length}>
          { servicesItem.length > 0 ? items : '' }
        </ShowcaseImagesWrapper>
    </PipeProvider>
  );
};

ShowcaseImages.propTypes = {
  type: PropTypes.string.isRequired
};

export default ShowcaseImages;
